@let color = shownColor();
@let size = shownSize();

<!-- pointerdown com preventDefault: os botões não roubam a seleção do editor. -->
<div class="toolbar" (pointerdown)="keepSelection($event)">

    <!-- Classe da linha (título, subtítulo, texto) no item de texto em foco; tipo do item nos outros -->
    <div class="group" role="group" [attr.aria-label]="'document.edit.toolbar.type' | translate">
        @for (option of typeOptions; track option.type) {
            <button
                type="button"
                class="tb-btn tb-type"
                [class.on]="canType() && currentType() === option.type"
                [disabled]="!canType()"
                [attr.aria-pressed]="canType() && currentType() === option.type"
                [raEditTooltip]="{ text: (option.labelKey | translate), position: 'bottom' }"
                (click)="setType(option.type)">
                <ra-icon [icon]="option.icon" varColor="currentColor" [size]="16" />
                <span>{{ option.labelKey | translate }}</span>
            </button>
        }
    </div>

    <span class="sep"></span>

    <!-- Fonte do documento (vale para o documento inteiro): dropdown com as famílias -->
    <div class="font-wrapper" clickOutside [clickOutsideEnabled]="showFontMenu()" (clickOutside)="showFontMenu.set(false)">
        <button
            type="button"
            class="tb-btn tb-font"
            [class.on]="showFontMenu()"
            [disabled]="blocked()"
            [attr.aria-expanded]="showFontMenu()"
            [raEditTooltip]="showFontMenu() ? null : { text: ('document.edit.toolbar.fontHint' | translate), position: 'bottom' }"
            (click)="showFontMenu.update(open => !open)">
            <ra-icon icon="text" varColor="currentColor" [size]="16" />
            <span [style.font-family]="shownFont()">{{ fontLabel() }}</span>
            <ra-icon class="tb-chevron" icon="arrow-down" varColor="currentColor" [size]="12" />
        </button>

        @if (showFontMenu()) {
            <div class="font-menu" role="listbox">
                @for (option of fontOptions; track option.family) {
                    <button
                        type="button"
                        class="font-option"
                        role="option"
                        [class.current]="option.family === shownFont()"
                        [attr.aria-selected]="option.family === shownFont()"
                        (click)="selectFont(option.family)">
                        <span [style.font-family]="option.family">{{ option.label }}</span>
                        @if (option.family === shownFont()) {
                            <ra-icon icon="check" varColor="currentColor" [size]="14" />
                        }
                    </button>
                }
            </div>
        }
    </div>

    <!-- Tamanho do texto do campo -->
    <div class="stepper" [class.custom]="size !== null" [class.disabled]="!canSize()">
        <button
            type="button"
            class="step"
            [disabled]="!canSize()"
            [attr.aria-label]="'document.edit.textCard.sizeDecrease' | translate"
            (click)="stepSize(-1)">
            <ra-icon icon="minus" varColor="currentColor" [size]="14" />
        </button>
        <label class="size-field">
            <input
                type="text"
                inputmode="decimal"
                autocomplete="off"
                [value]="sizeText()"
                [disabled]="!canSize()"
                [attr.aria-label]="'document.edit.textCard.size' | translate"
                (pointerdown)="$event.stopPropagation()"
                (input)="onSizeInput($event)"
                (keydown)="onSizeKeydown($event)"
                (blur)="commitSize()" />
            <span>pt</span>
        </label>
        <button
            type="button"
            class="step"
            [disabled]="!canSize()"
            [attr.aria-label]="'document.edit.textCard.sizeIncrease' | translate"
            (click)="stepSize(1)">
            <ra-icon icon="add" varColor="currentColor" [size]="14" />
        </button>
    </div>

    <span class="sep"></span>

    <!-- Negrito, itálico, sublinhado: no trecho selecionado do editor em foco -->
    <div class="group">
        <button
            type="button"
            class="tb-btn tb-icon glyph-b"
            [class.on]="editorFocused() && isBold()"
            [disabled]="!editorFocused()"
            [attr.aria-pressed]="editorFocused() && isBold()"
            [raEditTooltip]="{ text: ('document.edit.toolbar.bold' | translate), position: 'bottom' }"
            (click)="toggleFormat('bold')">B</button>
        <button
            type="button"
            class="tb-btn tb-icon glyph-i"
            [class.on]="editorFocused() && isItalic()"
            [disabled]="!editorFocused()"
            [attr.aria-pressed]="editorFocused() && isItalic()"
            [raEditTooltip]="{ text: ('document.edit.toolbar.italic' | translate), position: 'bottom' }"
            (click)="toggleFormat('italic')">I</button>
        <button
            type="button"
            class="tb-btn tb-icon glyph-u"
            [class.on]="editorFocused() && isUnderline()"
            [disabled]="!editorFocused()"
            [attr.aria-pressed]="editorFocused() && isUnderline()"
            [raEditTooltip]="{ text: ('document.edit.toolbar.underline' | translate), position: 'bottom' }"
            (click)="toggleFormat('underline')">U</button>

        <!-- Cor: do trecho selecionado ou, sem seleção, do campo inteiro -->
        <div class="color-wrapper" clickOutside [clickOutsideEnabled]="showColorMenu()" (clickOutside)="showColorMenu.set(false)">
            <button
                type="button"
                class="tb-btn tb-icon color-btn"
                [class.on]="showColorMenu()"
                [disabled]="!canColor() && !editorFocused()"
                [raEditTooltip]="showColorMenu() ? null : { text: ('document.edit.toolbar.color' | translate), position: 'bottom' }"
                (click)="showColorMenu.update(open => !open)">
                <span class="color-glyph" aria-hidden="true">
                    <b>A</b>
                    <i [class.default]="color === null" [style.background-color]="color"></i>
                </span>
            </button>

            @if (showColorMenu()) {
                <div class="color-menu">
                    <p class="menu-title">{{ 'document.edit.toolbar.color' | translate }}</p>
                    <div class="color-grid">
                        <button
                            type="button"
                            class="color-option"
                            [class.current]="color === null"
                            [attr.aria-label]="'document.edit.textCard.default' | translate"
                            [raEditTooltip]="{ text: ('document.edit.textCard.default' | translate), position: 'top' }"
                            (click)="selectColor(null)">
                            <span class="swatch swatch-default"></span>
                        </button>
                        @for (choice of colorChoices; track choice.hex) {
                            <button
                                type="button"
                                class="color-option"
                                [class.current]="color === choice.hex"
                                [attr.aria-label]="choice.labelKey | translate"
                                [raEditTooltip]="{ text: (choice.labelKey | translate), position: 'top' }"
                                (click)="selectColor(choice.hex)">
                                <span class="swatch" [style.background-color]="choice.hex"></span>
                            </button>
                        }
                        <label
                            class="color-option color-custom"
                            [class.current]="isCustomColor()"
                            [attr.aria-label]="'document.edit.textCard.colorCustom' | translate"
                            [raEditTooltip]="{ text: ('document.edit.textCard.colorCustom' | translate), position: 'top' }">
                            <span class="swatch swatch-custom"></span>
                            <input
                                type="color"
                                [value]="color ?? '#141515'"
                                (pointerdown)="$event.stopPropagation()"
                                (input)="onColorInput($event)"
                                (change)="onColorChange($event)" />
                        </label>
                    </div>
                </div>
            }
        </div>
    </div>

    <span class="sep"></span>

    <!-- Marca-texto (fundo do trecho), listas e limpar formatação: no editor em foco -->
    <div class="group">
        <div class="color-wrapper" clickOutside [clickOutsideEnabled]="showHighlightMenu()" (clickOutside)="showHighlightMenu.set(false)">
            <button
                type="button"
                class="tb-btn tb-icon color-btn"
                [class.on]="showHighlightMenu()"
                [disabled]="!editorFocused()"
                [raEditTooltip]="showHighlightMenu() ? null : { text: ('document.edit.toolbar.highlight' | translate), position: 'bottom' }"
                (click)="showHighlightMenu.update(open => !open)">
                <span class="color-glyph" aria-hidden="true">
                    <ra-icon icon="highlight" varColor="currentColor" [size]="16" />
                    <i [class.default]="currentHighlight() === null" [style.background-color]="currentHighlight()"></i>
                </span>
            </button>

            @if (showHighlightMenu()) {
                <div class="color-menu">
                    <p class="menu-title">{{ 'document.edit.toolbar.highlight' | translate }}</p>
                    <div class="color-grid">
                        <button
                            type="button"
                            class="color-option"
                            [class.current]="currentHighlight() === null"
                            [attr.aria-label]="'document.edit.toolbar.highlightNone' | translate"
                            [raEditTooltip]="{ text: ('document.edit.toolbar.highlightNone' | translate), position: 'top' }"
                            (click)="selectHighlight(null)">
                            <span class="swatch swatch-default"></span>
                        </button>
                        @for (hex of highlightChoices; track hex) {
                            <button
                                type="button"
                                class="color-option"
                                [class.current]="currentHighlight() === hex"
                                [attr.aria-label]="hex"
                                (click)="selectHighlight(hex)">
                                <span class="swatch" [style.background-color]="hex"></span>
                            </button>
                        }
                    </div>
                </div>
            }
        </div>

        <button
            type="button"
            class="tb-btn tb-icon"
            [class.on]="currentList() === 'bullet'"
            [disabled]="!editorFocused()"
            [attr.aria-pressed]="currentList() === 'bullet'"
            [raEditTooltip]="{ text: ('document.edit.toolbar.bulletList' | translate), position: 'bottom' }"
            (click)="toggleList('bullet')">
            <ra-icon icon="list-bullet" varColor="currentColor" [size]="18" />
        </button>
        <button
            type="button"
            class="tb-btn tb-icon"
            [class.on]="currentList() === 'ordered'"
            [disabled]="!editorFocused()"
            [attr.aria-pressed]="currentList() === 'ordered'"
            [raEditTooltip]="{ text: ('document.edit.toolbar.numberedList' | translate), position: 'bottom' }"
            (click)="toggleList('ordered')">
            <ra-icon icon="list-number" varColor="currentColor" [size]="18" />
        </button>
        <button
            type="button"
            class="tb-btn tb-icon"
            [disabled]="!editorFocused()"
            [raEditTooltip]="{ text: ('document.edit.toolbar.clearFormat' | translate), position: 'bottom' }"
            (click)="clearFormat()">
            <ra-icon icon="eraser" varColor="currentColor" [size]="18" />
        </button>
    </div>

    <span class="sep"></span>

    <!-- Alinhamento do documento (config textAlign) -->
    <div class="group" role="group" [attr.aria-label]="'document.edit.toolbar.align' | translate">
        <button
            type="button"
            class="tb-btn tb-icon"
            [class.on]="textAlign() === 'left'"
            [disabled]="blocked()"
            [attr.aria-pressed]="textAlign() === 'left'"
            [raEditTooltip]="{ text: ('document.edit.toolbar.alignLeft' | translate), position: 'bottom' }"
            (click)="setAlign('left')">
            <ra-icon icon="textalign-left" varColor="currentColor" [size]="18" />
        </button>
        <button
            type="button"
            class="tb-btn tb-icon"
            [class.on]="textAlign() === 'justify'"
            [disabled]="blocked()"
            [attr.aria-pressed]="textAlign() === 'justify'"
            [raEditTooltip]="{ text: ('document.edit.toolbar.alignJustify' | translate), position: 'bottom' }"
            (click)="setAlign('justify')">
            <ra-icon icon="textalign-justify" varColor="currentColor" [size]="18" />
        </button>
    </div>

    <!-- "Inserir campo" saiu daqui (2026-09-25): virou o botão flutuante no pé da folha
         (insert-field-fab), onde fica sempre à vista e perto de onde o campo entra. -->
</div>
